import { FormControl } from '@angular/forms';

import { TokenTypeId } from '@ap/interface-apic-authenticatie-fido';

export interface SignCredentials {
    username: string;
}

export interface SignResponse {
    // token id/username
    keyID: string;
    // challenge response
    response?: string;
}

export interface SignResponseForm {
    keyID: FormControl<string>;
    response: FormControl<string>;
}

export interface SignError {
    // the content key
    key: string;
    // notification type
    type: 'error' | 'warning';
}

export const SignTokenBrowserRegister = 'browser.register';

// be aware that each token needs a sign.title.<tokenType> in sign.content
export enum SignToken {
    NATIVE_APP = 'NATIVE_APP',
    DIGICODE = 'DIGICODE',
    DIGIPAS = 'DIGIPAS',
    PROSPECT_DIGICODE = 'PROSPECT_DIGICODE',
    BROWSER = 'BROWSER',
    PHONE_NUMBER = 'PHONE_NUMBER'
}

export const SignTokenToLsmTokenMap = new Map<TokenTypeId, SignToken>([
    [TokenTypeId.DIGIPAS, SignToken.DIGIPAS],
    [TokenTypeId.DIGICODE, SignToken.DIGICODE],
    [TokenTypeId.PROSPECT_DIGICODE, SignToken.PROSPECT_DIGICODE],
    [TokenTypeId.MOBILE_DEVICE, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_PINCODE, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_FINGERPRINT, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_FACE, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_BIOMETRIC, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_DEVICE_HIGH, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_DEVICE_LOW, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_PINCODE_HIGH, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_PINCODE_LOW, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_FINGERPRINT_HIGH, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_FINGERPRINT_LOW, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_FACE_HIGH, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_FACE_LOW, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_BIOMETRIC_HIGH, SignToken.NATIVE_APP],
    [TokenTypeId.MOBILE_BIOMETRIC_LOW, SignToken.NATIVE_APP],
    [TokenTypeId.BROWSER_DEVICE, SignToken.BROWSER],
    [TokenTypeId.BROWSER_PINCODE, SignToken.BROWSER],
    [TokenTypeId.PHONE_NUMBER, SignToken.PHONE_NUMBER]
]);

export interface PendingToken {
    keychainId: string;
    pincode: string;
}
